<template>
  <v-dialog v-model="dialogSyncDeviceResponseData" scrollable max-width="540px">
    <v-card>
      <v-card-title class="grey lighten-2">
        <span>
          {{ responseData.hardware ? responseData.hardware.title_th : '' }}
        </span>

        <v-spacer></v-spacer>

        <v-btn icon @click="$emit('onCloseDialogSyncDeviceResponseData')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text
        class="pt-5"
        v-if="
          responseData.hardware &&
          [
            'acu01r',
            'acu81',
            'cru67rc',
            'cru67rf',
            'cru77rf',
            'q3rac',
            'tat51i',
            'vf600',
            'vf1000',
            'vf1000r',
          ].includes(responseData.hardware.hardware_model.hardware_model_code)
        "
      >
        <div v-if="responseData.command === 'get_access_authority_list'">
          <div v-if="responseData.is_success">
            <p class="ma-0">
              พนักงาน ( ทั้งหมด
              {{ Object.keys(groupBy(responseData.response_json.data)).length }}
              คน )
            </p>
            <p>
              อัพเดทล่าสุด:
              {{
                new Date(responseData.response_json.last_update_utc)
                  | dateTimeFormat
              }}
            </p>
            <v-list-item
              class="pa-0 mb-2"
              v-for="(value, key) in groupBy(responseData.response_json.data)"
              :key="key"
            >
              <v-list-item-content class="grey lighten-3 pl-4">
                <v-list-item-title>รหัสพนักงาน: {{ key }}</v-list-item-title>
                <div style="color: #757575; line-height: 1.5">
                  Timezone:
                  <span v-for="(item, i) in value" :key="i">
                    {{ item.timezone_code
                    }}<span v-if="i + 1 < value.length">,</span>
                  </span>
                </div>
                <div style="color: #757575; line-height: 1.5">
                  Start Datetime:
                  <span v-for="(item, i) in value" :key="i">
                    <span
                      v-if="
                        item.access_control_datetime[0]
                          .access_control_start_datetime
                      "
                    >
                      {{
                        item.access_control_datetime[0]
                          .access_control_start_datetime
                          | dateTimeFormatWithoutTimeSecond
                      }}
                    </span>
                    <span v-else>-</span>
                  </span>
                </div>
                <div style="color: #757575; line-height: 1.5">
                  End Datetime:
                  <span v-for="(item, i) in value" :key="i">
                    <span
                      v-if="
                        item.access_control_datetime[0]
                          .access_control_end_datetime
                      "
                    >
                      {{
                        item.access_control_datetime[0]
                          .access_control_end_datetime
                          | dateTimeFormatWithoutTimeSecond
                      }}
                    </span>
                    <span v-else>-</span>
                  </span>
                </div>
              </v-list-item-content>
            </v-list-item>
          </div>
          <div v-else>
            <v-list-item
              two-line
              v-for="(value, key) in responseData.response_json"
              :key="key"
            >
              <v-list-item-content>
                <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ value }}
                </p>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>

        <div v-else-if="responseData.command === 'set_unlock'">
          <v-list-item
            two-line
            v-for="(value, key) in responseData.response_json"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div v-else-if="responseData.command === 'set_lock'">
          <v-list-item
            two-line
            v-for="(value, key) in responseData.response_json"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div v-else-if="responseData.command === 'set_bell'">
          <v-list-item
            two-line
            v-for="(value, key) in responseData.response_json"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div v-else-if="responseData.command === 'set_timezone_list'">
          <v-list-item
            two-line
            v-for="(value, key) in responseData.response_json"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div v-else-if="responseData.command === 'set_holiday_list'">
          <v-list-item
            two-line
            v-for="(value, key) in responseData.response_json"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div v-else-if="responseData.command === 'set_access_authority_list'">
          <v-list-item
            two-line
            v-for="(value, key) in responseData.response_json"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div v-else-if="responseData.command === 'delete_employee'">
          <v-list-item
            two-line
            v-for="(value, key) in responseData.response_json"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div v-else-if="responseData.command === 'get_employee'">
          <div v-if="responseData.is_success">
            <div
              v-if="
                ['acu01r', 'cru77rf', 'vf1000r'].includes(
                  responseData.hardware.hardware_model.hardware_model_code
                )
              "
            >
              <div
                v-for="group in responseData.response_json"
                :key="group.group_key"
                class="mb-6"
              >
                <div>
                  <p
                    class="mb-2"
                    style="font-weight: 600; font-size: 16px; color: #212121"
                  >
                    {{ group.group_name }}
                  </p>
                  <v-divider></v-divider>
                  <v-list-item
                    class="pl-0"
                    two-line
                    v-for="item in group.items"
                    :key="group.group_key + '_' + item.key"
                  >
                    <v-list-item-content
                      v-if="
                        (item.key === 'photo_identifier' ||
                          item.key === 'face_data') &&
                        item.value
                      "
                    >
                      <v-list-item-subtitle>
                        {{ item.key_name }}
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        <v-img
                          style="width: 64px"
                          :src="'data:image/jpeg;base64,' + item.value"
                          aspect-ratio="1"
                        ></v-img>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                      <v-list-item-subtitle>
                        {{ item.key_name }}
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ item.value || '-' }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </div>

            <div v-else>
              <v-list-item
                two-line
                v-for="(value, key) in command.responseData"
                :key="key"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
                  <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                    {{ value }}
                  </p>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
          <div v-else>
            <div
              v-if="
                ['acu01r', 'cru77rf', 'vf1000r'].includes(
                  responseData.hardware.hardware_model.hardware_model_code
                )
              "
            >
              <div
                v-for="group in responseData.response_json"
                :key="group.group_key"
                class="mb-6"
              >
                <div>
                  <p
                    class="mb-2"
                    style="font-weight: 600; font-size: 16px; color: #212121"
                  >
                    {{ group.group_name }}
                  </p>
                  <v-divider></v-divider>
                  <v-list-item
                    class="pl-0"
                    two-line
                    v-for="item in group.items"
                    :key="group.group_key + '_' + item.key"
                  >
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        {{ item.key_name }}
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ item.value || '-' }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </div>

            <div v-else>
              <v-list-item
                two-line
                v-for="(value, key) in responseData.response_json"
                :key="key"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
                  <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                    {{ value }}
                  </p>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </div>

        <div v-else-if="responseData.command === 'get_last_update'">
          <div v-if="responseData.is_success">
            <p>
              พนักงาน ( ทั้งหมด
              {{ responseData.response_json.employee.data.length }} คน )
            </p>
            <v-list-item
              class="pa-0 mb-2"
              v-for="item in responseData.response_json.employee.data"
              :key="item.employee_code"
            >
              <v-list-item-content class="grey lighten-3 pl-4">
                <v-list-item-title>
                  รหัสพนักงาน: {{ item.employee_code }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <span v-if="item.last_update_utc">
                    อัพเดทล่าสุด: {{ item.last_update_utc | dateTimeFormat }}
                  </span>
                  <span v-else>อัพเดทล่าสุด: - </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
          <div v-else>
            <v-list-item
              two-line
              v-for="(value, key) in responseData.response_json"
              :key="key"
            >
              <v-list-item-content>
                <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ value }}
                </p>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>

        <div v-else-if="responseData.command === 'get_employee_list'">
          <div v-if="responseData.is_success">
            <div
              v-if="
                ['acu01r', 'cru77rf', 'vf1000r'].includes(
                  responseData.hardware.hardware_model.hardware_model_code
                )
              "
            >
              <div
                v-for="item in responseData.response_json"
                :key="item.group_key"
              >
                <p>
                  {{ item.group_name.replace('$total', item.items.length) }}
                </p>
                <v-list-item
                  class="pa-0 mb-2"
                  v-for="(subItem, index) in item.items"
                  :key="index"
                >
                  <v-list-item-content class="grey lighten-3 px-4">
                    <v-list-item-title>
                      {{ subItem[0].key_name }}: {{ subItem[0].value }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="mt-1"
                      v-for="sub in subItem.slice(1)"
                      :key="sub.key_name"
                    >
                      {{ sub.key_name }}:
                      <span v-if="sub.value">
                        {{ sub.value | dateTimeFormat }}
                      </span>
                      <span v-else>-</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </div>

            <div v-else>
              <p>
                พนักงาน ( ทั้งหมด
                {{ responseData.response_json.employee.data.length }} คน )
              </p>
              <v-list-item
                class="pa-0 mb-2"
                v-for="item in responseData.response_json.employee.data"
                :key="item.employee_code"
              >
                <v-list-item-content class="grey lighten-3 pl-4">
                  <v-list-item-title>
                    รหัสพนักงาน: {{ item.employee_code }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span v-if="item.last_update_utc">
                      อัพเดทล่าสุด: {{ item.last_update_utc | dateTimeFormat }}
                    </span>
                    <span v-else>อัพเดทล่าสุด: - </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
          <div v-else>
            <div
              v-if="
                ['acu01r', 'cru77rf', 'vf1000r'].includes(
                  responseData.hardware.hardware_model.hardware_model_code
                )
              "
            >
              <div
                v-for="group in responseData.response_json"
                :key="group.group_key"
                class="mb-6"
              >
                <div>
                  <p
                    class="mb-2"
                    style="font-weight: 600; font-size: 16px; color: #212121"
                  >
                    {{ group.group_name }}
                  </p>
                  <v-divider></v-divider>
                  <v-list-item
                    class="pl-0"
                    two-line
                    v-for="item in group.items"
                    :key="group.group_key + '_' + item.key"
                  >
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        {{ item.key_name }}
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ item.value || '-' }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </div>

            <div v-else>
              <v-list-item
                two-line
                v-for="(value, key) in responseData.response_json"
                :key="key"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
                  <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                    {{ value }}
                  </p>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </div>

        <div
          v-else-if="
            responseData.command === 'get_device_info' &&
            ['acu81', 'cru67rc', 'cru67rf', 'q3rac', 'tat51i'].includes(
              responseData.hardware.hardware_model.hardware_model_code
            )
          "
        >
          <v-list-item
            two-line
            v-for="(value, key) in responseData.response_json"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div
          v-else-if="
            responseData.command === 'get_device_info' &&
            ['acu01r', 'cru77rf', 'vf1000r'].includes(
              responseData.hardware.hardware_model.hardware_model_code
            )
          "
        >
          <div
            v-for="group in responseData.response_json"
            :key="group.group_key"
            class="mb-6"
          >
            <div>
              <p
                class="mb-2"
                style="font-weight: 600; font-size: 16px; color: #212121"
              >
                {{ group.group_name }}
              </p>
              <v-divider></v-divider>
              <v-list-item
                class="pl-0"
                two-line
                v-for="item in group.items"
                :key="group.group_key + '_' + item.key"
              >
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ item.key_name }}
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ item.value || '-' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </div>

        <div
          v-else-if="
            responseData.command === 'get_device_info' &&
            ['vf1000', 'vf600'].includes(
              responseData.hardware.hardware_model.hardware_model_code
            )
          "
        >
          <div v-if="responseData.is_success">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>SN ของ Device</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.sn || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>ชื่อรุ่นของ Device</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.type || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>ชื่อเรียกของ Device</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.name || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>วันเวลาของ Device</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.time || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Algorithm Version</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.alg_edition || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Firmware Version</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.edition || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>IP address</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.ip || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Gateway</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.gateway || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Subnet mask</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.netmask || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>MAC address</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.mac || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>managerlock</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.managerlock || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>ลงทะเบียน admin ได้สูงสุด</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.max_managernum || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>ลงทะเบียน admin ไปแล้ว</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.managernum || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>ลงทะเบียนพนักงานได้สูงสุด</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.max_employee || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>ลงทะเบียนพนักงานไปแล้ว</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.real_employee || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title
                  >บันทึก Transaction ได้สูงสุด</v-list-item-title
                >
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.max_facerecord || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>บันทึก Transaction ไปแล้ว</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.real_facerecord || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>ระดับความดังเสียง</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ responseData.response_json.volume || '-' }}
                </p>
              </v-list-item-content>
            </v-list-item>
          </div>
          <div v-else>
            <v-list-item
              two-line
              v-for="(value, key) in responseData.response_json"
              :key="key"
            >
              <v-list-item-content>
                <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
                <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                  {{ value }}
                </p>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>

        <div v-else-if="responseData.command === 'set_employee'">
          <v-list-item
            two-line
            v-for="(value, key) in responseData.response_json"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div v-else-if="responseData.command === 'set_device_info'">
          <v-list-item
            two-line
            v-for="(value, key) in responseData.response_json"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div v-else-if="responseData.command === 'set_firmware'">
          <v-list-item
            two-line
            v-for="(value, key) in responseData.response_json"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div v-else>Not Support Command</div>
      </v-card-text>
      <v-card-text class="pt-5" v-else>Not Support Device</v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'DialogSyncDeviceResponseData',
  props: {
    dialogSyncDeviceResponseData: {
      type: Boolean,
      default: false,
    },
    responseData: {
      type: Object,
      default: () => ({}),
    },
  },
  filters: {
    dateTimeFormat: function (value) {
      if (!value) return
      return moment(value).format('DD/MM/YYYY HH:mm:ss')
    },
    dateTimeFormatWithoutTimeSecond: function (value) {
      if (!value) return
      return moment(value).format('DD/MM/YYYY HH:mm')
    },
  },
  methods: {
    groupBy(value) {
      const results = _.groupBy(value, 'employee_code')
      return results
    },
  },
}
</script>
